import React from 'react';

import { Plan } from '@api/types';
import GetInTouch from '@react/Pages/AccountSettingsPage/YourDataSection/PricingPlanTile/GetInTouch';
import {
  allowChangePlan,
  allowChoosePlan,
  allowDowngradePlan,
} from '@redux/ducks/account/pricingPlan/pricingPlans.utils';

export interface PlanActionButtonProps {
  plan: Plan;
  onCancel: (plan: Plan) => void;
  onConfirm: (plan: Plan) => void;
  currentPlan?: Plan;
}

export interface CancelPlanChangeButtonProps {
  downgradeOn: string;
  onCancel: () => void;
}

export interface ChangePlanButtonProps {
  label: string;
  onConfirm: () => void;
}

const CurrentPlanButton: React.FC = () => <div className="pricing-plan__active-notice">{t('label.active-plan')}</div>;

const ChangePlanButton: React.FC<ChangePlanButtonProps> = ({ label, onConfirm }) => (
  <button type="button" className="btn pricing-plan__button" onClick={onConfirm}>
    {label}
  </button>
);

const CancelPlanChangeButton: React.FC<CancelPlanChangeButtonProps> = ({ downgradeOn, onCancel }) => (
  <>
    <p className="pricing-plan__downgrade-date">{`${t('label.downgrade-on')} ${downgradeOn}`}</p>
    <button type="button" className="btn pricing-plan__button" onClick={onCancel}>
      {t('action.cancel')}
    </button>
  </>
);

export const PricingPlanActionButton: React.FC<PlanActionButtonProps> = ({
  plan,
  currentPlan,
  onCancel,
  onConfirm,
}) => {
  const isChooseAllowed = allowChoosePlan(plan, currentPlan);

  if (isChooseAllowed) {
    return <ChangePlanButton label={t('action.choose')} onConfirm={() => onConfirm(plan)} />;
  }

  if (plan.current) {
    return <CurrentPlanButton />;
  }

  if (plan.scheduled) {
    const [downgradeOn] = plan.activeSince.split('T');

    return <CancelPlanChangeButton downgradeOn={downgradeOn} onCancel={() => onCancel(plan)} />;
  }

  const isChangeAllowed = allowChangePlan(plan, currentPlan);
  const isDowngradeAllowed = allowDowngradePlan(plan, currentPlan);

  if (isChangeAllowed) {
    return (
      <ChangePlanButton
        label={isDowngradeAllowed ? t('action.downgrade') : t('action.upgrade')}
        onConfirm={() => onConfirm(plan)}
      />
    );
  }

  return <GetInTouch />;
};
